module.exports = __webpack_public_path__ + "img/55200.7870f3c0.jpg";